import React, { useEffect } from 'react';
import styled from 'styled-components';
import HeroSection from '../components/sections/hero-section';
import FeaturesSection from '../components/sections/features-section';
// import TestimonialsSection from '../components/sections/testimonials-section';
import CtaSection from '../components/sections/cta-section';

const HomePage: React.FC = () => {
  useEffect(() => {
    document.title = 'FylePrep - Streamline Tax Preparation For CPA Practices';
  }, []);

  return (
    <>
      <HeroSection />
      <FeaturesSection />
      {/* <TestimonialsSection /> */}
      <CtaSection />
    </>
  );
};

export default HomePage;
